import React from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import * as styles from './costAndFeesModule.styles';

export const LeaseTermsInline = () => {
  const leaseTerms = useSelector(
    (state: RootReduxState) => state.currentListingDetails?.currentListing?.details?.leaseTerms,
  );

  if (!leaseTerms) return null;

  return (
    <div>
      <h3 className={styles.sectionHeading}>Lease terms</h3>
      <p className={styles.leaseTermsText}>{leaseTerms}</p>
    </div>
  );
};
